import React from "react";
import classes from "./index.module.css";
import RadioButtonActive from "../../assets/radio-active.svg";
import RadioButtonInactive from "../../assets/radio-inactive.svg";

const RadioButton = ({ text, isActive, setActive, subheading }) => {
  return (
    <div
      className={
        isActive ? `${classes.container} ${classes.active}` : classes.container
      }
      onClick={() => setActive(text)}
      style={{ height: subheading ? "70px" : "60px" }}
    >
      {subheading ? (
        <div>
          <p style={{ fontWeight: "bold", marginBottom: "8px" }}>{text}</p>
          <p className={classes.subheading}>{subheading}</p>
        </div>
      ) : (
        <div>
          <p>{text}</p>
        </div>
      )}

      {isActive ? (
        <img src={RadioButtonActive} alt="active" />
      ) : (
        <img src={RadioButtonInactive} alt="inactive" />
      )}
    </div>
  );
};

export default RadioButton;
